import cx from 'classnames';
import { defineMessages, useIntl } from 'react-intl';

import type {
  NationViewProps,
  qubicaBaseSections,
} from '../NationView/NationView';

import RepresentativesCards from './RepresentativesCards';

import styles from './styles.module.css';
import QubicaBaseCard from './QubicaBaseCard';
import type {
  QubicaContactCardsStyleProps,
  QubicaContentProps,
  representativeSections,
} from './utils';

type SectionType =
  | (typeof representativeSections)[number]
  | (typeof qubicaBaseSections)[number];

const CardsSection = ({
  content,
  section,
  bg = 'white',
}: {
  content: NationViewProps['content'];
  section: SectionType;
  bg?: QubicaContactCardsStyleProps['bg'];
}) => {
  const intl = useIntl();
  return content[section].length > 0 ? (
    <div>
      {content[section].every(
        (el: QubicaContentProps) => el['@type'] === 'Contact',
      ) ? (
        <h3 className={styles.sectionTitle}>
          {intl.formatMessage({ id: section + '_label' })}
        </h3>
      ) : (
        <h2 className={cx(styles.sectionTitle, styles.macroSectionTitle)}>
          {intl.formatMessage({ id: section + '_label' })}
        </h2>
      )}
      <div className={styles.cardsContainer}>
        {content[section].map((el: QubicaContentProps) => {
          return el['@type'] === 'Contact' ? (
            <RepresentativesCards key={el['@id']} content={el} bg={bg} />
          ) : (
            <QubicaBaseCard key={el['@id']} content={el} bg={bg} />
          );
        })}
      </div>
    </div>
  ) : (
    <></>
  );
};

export default CardsSection;

const messages = defineMessages({
  district_sales_manager_label: {
    id: 'district_sales_manager_label',
    defaultMessage: 'District sales manager',
  },
  regional_sales_manager_label: {
    id: 'regional_sales_manager_label',
    defaultMessage: 'Regional sales manager',
  },
  SVP_sales_label: {
    id: 'SVP_sales_label',
    defaultMessage: 'SVP sales',
  },
  VP_sales_label: {
    id: 'VP_sales_label',
    defaultMessage: 'VP sales',
  },
  product_specialist_label: {
    id: 'product_specialist_label',
    defaultMessage: 'Product specialist',
  },
  technical_support_label: {
    id: 'technical_support_label',
    defaultMessage: 'Technical support',
  },
  representative_office_label: {
    id: 'representative_office_label',
    defaultMessage: 'Representative office',
  },
  crm_label: {
    id: 'crm_label',
    defaultMessage: 'CRM',
  },
  sales_assistant_label: {
    id: 'sales_assistant_label',
    defaultMessage: 'Sales Assistant',
  },
  us_parts_and_suppliera_distributor_label: {
    id: 'us_parts_and_suppliera_distributor_label',
    defaultMessage: 'US Parts and Supplies Distributor',
  },
  specific_locale_label: {
    id: 'specific_locale_label',
    defaultMessage: 'Locale in the current country',
  },
  related_locale_label: {
    id: 'related_locale_label',
    defaultMessage: 'Related locale',
  },
  headquarter_label: {
    id: 'Headquarters',
    defaultMessage: 'Headquarters',
  },
});
